import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setBodyTheme, removeBodyTheme } from "../services/theme";

/**
 * Custom hook to manage theme based on customer type
 * Automatically sets data-theme="dark" on body when customerType is "the_point"
 * 
 * @returns {void}
 */
const useTheme = () => {
  const stateProfile = useSelector((state) => state.profile);

  useEffect(() => {
    const customerType = stateProfile?.dataUser?.customerType;

    if (customerType === "the_point") {
      setBodyTheme(customerType, "dark");
    } else {
      removeBodyTheme();
    }

    // Cleanup function to remove attribute when component unmounts
    return () => {
      removeBodyTheme();
    };
  }, [stateProfile?.dataUser?.customerType]);
};

export default useTheme;

